import React from 'react';
import { Group, Rect, Line, Arc } from 'react-konva';

// hingeEnd: لولا سمتِ دیگرِ در (آینه در طولِ در)
function Dar({ x, y, length, angleDeg, thickness = 8, selected = false, flip = false, hingeEnd = false, onPointerDown }) {
  const color = selected ? '#0a66c2' : '#000000';
  // flip=false → «رو به بیرون» (لنگه در روی سمت پیش‌فرض دیوار باز می‌شود)
  // flip=true  → «رو به داخل» (کل لنگه + کمان بازشدن، آینه‌ای، روی سمت دیگر دیوار می‌رود)
  const dir = flip ? 1 : -1;

  return (
    <Group x={x} y={y} rotation={angleDeg} onPointerDown={onPointerDown}>
      {/* ناحیه نامرئی و بزرگ‌تر برای راحتی لمس روی موبایل */}
      <Rect x={-6} y={-thickness / 2 - 10} width={length + 12} height={thickness + 20} fill="#000000" opacity={0} />
      <Rect x={0} y={-thickness / 2} width={length} height={thickness} fill="#ffffff" />
      <Group x={hingeEnd ? length : 0} scaleX={hingeEnd ? -1 : 1}>
      <Line points={[0, 0, 0, dir * length]} stroke={color} strokeWidth={selected ? 3 : 2} />
      <Arc
        x={0}
        y={0}
        innerRadius={0}
        outerRadius={length}
        angle={90}
        rotation={flip ? 0 : -90}
        stroke={selected ? '#0a66c2' : '#c7c7c7'}
        strokeWidth={1}
        dash={[4, 4]}
      />
      </Group>
    </Group>
  );
}

export default Dar;